/* Course-only campaign clock and native Shopify cart enhancement. No order submission. */
(function (scope) {
  'use strict';
  function campaignState(now, config) {
    const open = Date.parse(config.opens);
    const introEnd = Date.parse(config.introEnds);
    const close = Date.parse(config.closes);
    if (![now, open, introEnd, close].every(Number.isFinite) || !(open < introEnd && introEnd < close)) {
      return {phase: 'closed', target: null, label: 'Die Anmeldung ist abgelaufen', cta: 'Zum Newsletter anmelden', canBuy: false};
    }
    const phase = now < open ? 'before' : now < introEnd ? 'intro' : now < close ? 'regular' : 'closed';
    const targets = {before: open, intro: introEnd, regular: close, closed: null};
    const labels = {before: 'Die Anmeldung öffnet in', intro: 'Einführungspreis noch verfügbar für', regular: 'Anmeldung noch möglich für', closed: 'Die Anmeldung ist abgelaufen'};
    const ctas = {before: 'Kursvarianten ansehen', intro: 'Kurs zum Einführungspreis sichern', regular: 'Kurs sichern', closed: 'Zum Newsletter anmelden'};
    return {phase, target: targets[phase], label: labels[phase], cta: ctas[phase], canBuy: phase === 'intro' || phase === 'regular' || (phase === 'before' && config.qa === true)};
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = {campaignState};
  if (typeof document === 'undefined') return;

  function init(root) {
    if (!root || root.dataset.commerceReady) return;
    root.dataset.commerceReady = 'true';
    document.querySelectorAll('header [data-fms-course-cta]').forEach(link => {
      if (link.dataset.fmsNavReady) return;
      link.dataset.fmsNavReady = 'true';
      link.addEventListener('click', () => {
        // Use the theme's own close control so focus, body scrolling and animation reset together.
        const openMenu = document.querySelector('header-drawer details[open] > summary');
        if (openMenu) openMenu.click();
      });
    });
    const config = {opens: root.dataset.opens, introEnds: root.dataset.introEnds, webinarBonusEnds: root.dataset.webinarBonusEnds, closes: root.dataset.closes, qa: root.dataset.qa === 'true'};
    const money = cents => new Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR', maximumFractionDigits: 0}).format(cents / 100);
    const berlinDate = ms => new Intl.DateTimeFormat('de-DE', {timeZone: 'Europe/Berlin', day: '2-digit', month: '2-digit'}).format(ms);
    const berlinTime = ms => new Intl.DateTimeFormat('de-DE', {timeZone: 'Europe/Berlin', hour: '2-digit', minute: '2-digit'}).format(ms);
    const berlinLongDate = ms => new Intl.DateTimeFormat('de-DE', {timeZone: 'Europe/Berlin', day: 'numeric', month: 'long'}).format(ms);
    const webinarBonusIsActive = now => new URLSearchParams(scope.location.search).get('bonus') === 'webinar' && now >= Date.parse(config.opens) && now < Date.parse(config.webinarBonusEnds);
    let previousPhase;
    function render() {
      const now = Date.now();
      const state = campaignState(now, config);
      root.dataset.campaignState = state.phase;
      root.querySelectorAll('[data-fms-webinar-bonus]').forEach(panel => { panel.hidden = !webinarBonusIsActive(now); });
      root.querySelectorAll('[data-fms-countdown-label]').forEach(el => { el.textContent = state.label; });
      const total = Math.max(0, Math.floor(((state.target || now) - now) / 1000));
      const units = {days: Math.floor(total / 86400), hours: Math.floor(total / 3600) % 24, minutes: Math.floor(total / 60) % 60, seconds: total % 60};
      root.querySelectorAll('[data-fms-countdown]').forEach(clock => {
        clock.hidden = state.phase === 'closed';
        clock.querySelectorAll('[data-unit]').forEach(el => { el.textContent = String(units[el.dataset.unit]).padStart(2, '0'); });
      });
      root.querySelectorAll('[data-fms-closed-message]').forEach(el => { el.hidden = state.phase !== 'closed'; });
      root.querySelectorAll('[data-fms-campaign-cta]').forEach(el => {
        el.textContent = state.cta;
        el.setAttribute('href', state.phase === 'closed' ? '#contact_form' : '#pricing');
      });
      document.querySelectorAll('header [data-fms-course-cta]').forEach(el => {
        el.textContent = state.phase === 'before' ? 'Kursvarianten ansehen' : state.phase === 'closed' ? 'Zum Newsletter anmelden' : 'Kurs sichern';
        el.setAttribute('href', state.phase === 'closed' ? '#contact_form' : '#pricing');
      });
      root.querySelectorAll('[data-fms-deadline-value]').forEach(el => { el.textContent = state.phase === 'closed' ? 'Geschlossen' : berlinDate(state.phase === 'before' ? state.target : state.target - 1); });
      root.querySelectorAll('[data-fms-deadline-label]').forEach(el => {
        el.textContent = state.phase === 'before' ? `Anmeldung ab ${berlinTime(state.target)} Uhr` : state.phase === 'intro' ? 'Letzter Tag zum Einführungspreis' : state.phase === 'regular' ? 'Letzter Tag zur Anmeldung' : 'Die Anmeldung ist geschlossen';
      });
      root.querySelectorAll('[data-fms-tier]').forEach(card => {
        const regular = Number(card.dataset.regularPrice);
        const reduction = Number(card.dataset.reduction);
        const intro = Math.max(0, regular - reduction);
        const available = card.dataset.available === 'true';
        const button = card.querySelector('[data-fms-buy]');
        const price = card.querySelector('[data-fms-price]');
        if (price && regular > 0) price.textContent = money(state.phase === 'intro' ? intro : regular);
        const future = card.querySelector('[data-fms-future-price]');
        if (future) {
          future.hidden = state.phase !== 'intro';
          const regularValue = future.querySelector('s') || future;
          regularValue.textContent = money(regular);
        }
        const deadline = card.querySelector('[data-fms-price-deadline]');
        if (deadline) deadline.textContent = state.phase === 'before'
          ? `Einführungspreis ab ${berlinLongDate(Date.parse(config.opens))}, ${berlinTime(Date.parse(config.opens))} Uhr`
          : state.phase === 'intro'
            ? `Einführungspreis bis einschließlich ${berlinLongDate(Date.parse(config.introEnds) - 1)}`
            : state.phase === 'regular' ? 'Regulärer Kurspreis' : 'Die Anmeldung ist geschlossen';
        const note = card.querySelector('[data-fms-price-note]');
        if (note) note.textContent = state.phase === 'intro' ? 'Einführungspreis · Einmalzahlung' : 'Einmalzahlung';
        if (button && !button.dataset.busy) {
          button.disabled = !available || !state.canBuy || root.dataset.cartBusy === 'true';
          button.textContent = !available ? 'Zurzeit nicht verfügbar' : state.phase === 'closed' ? 'Anmeldung geschlossen' : !state.canBuy ? 'Anmeldung ab 11. September' : button.dataset.label;
        }
        if (previousPhase === 'intro' && state.phase === 'regular') {
          const status = card.querySelector('[data-fms-cart-status]');
          if (status) status.textContent = 'Der Einführungspreis ist abgelaufen. Es gilt jetzt der reguläre Kurspreis.';
        }
      });
      previousPhase = state.phase;
    }
    render();
    const interval = setInterval(() => { if (!root.isConnected) return clearInterval(interval); render(); }, 1000);
    document.addEventListener('visibilitychange', () => { if (!document.hidden && root.isConnected) render(); });
    scope.addEventListener('pageshow', () => {
      if (!root.isConnected) return;
      delete root.dataset.cartBusy;
      root.querySelectorAll('[data-fms-buy]').forEach(button => { delete button.dataset.busy; });
      render();
    });

    // Keep unrelated cart items, but make the two course tariffs mutually exclusive.
    // A valid webinar-offer URL records the promised bonus eligibility on the line item.
    const courseIds = new Set([...root.querySelectorAll('[data-fms-product-form] [name="id"]')].map(input => String(input.value)).filter(id => /^\d+$/.test(id)));
    root.querySelectorAll('[data-fms-product-form]').forEach(form => form.addEventListener('submit', async event => {
      event.preventDefault();
      const card = form.closest('[data-fms-tier]');
      const button = form.querySelector('[data-fms-buy]');
      const status = card.querySelector('[data-fms-cart-status]');
      if (root.dataset.cartBusy === 'true' || button.dataset.busy || !campaignState(Date.now(), config).canBuy || card.dataset.available !== 'true') { render(); return; }
      root.dataset.cartBusy = 'true';
      button.dataset.busy = 'true'; button.disabled = true; button.textContent = 'Wird hinzugefügt …'; status.textContent = '';
      render();
      try {
        const id = form.querySelector('[name="id"]').value;
        const webinarBonusProperties = webinarBonusIsActive(Date.now()) ? {'_FMS Webinar-Boni': 'Spickzettel für die Anti-Fehlkauf-Garantie · Sofort-Hilfe-PDF · persönliches Video'} : undefined;
        if (!/^\d+$/.test(id) || Number(id) <= 0) throw new Error('Diese Kursvariante ist zurzeit nicht verfügbar. Bitte lade die Seite neu.');
        const cartResponse = await fetch(root.dataset.cartUrl + '.js', {headers: {Accept: 'application/json'}, credentials: 'same-origin'});
        if (!cartResponse.ok) throw new Error('Der Warenkorb konnte nicht geladen werden. Bitte versuche es noch einmal.');
        const cart = await cartResponse.json();
        const existing = cart.items.find(item => String(item.variant_id) === id);
        const otherCourseItems = cart.items.filter(item => courseIds.has(String(item.variant_id)) && String(item.variant_id) !== id);
        if (otherCourseItems.length) {
          const updates = {};
          otherCourseItems.forEach(item => { updates[item.key] = 0; });
          const updateResponse = await fetch(root.dataset.cartUrl + '/update.js', {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, credentials: 'same-origin', body: JSON.stringify({updates})});
          if (!updateResponse.ok) throw new Error('Die bisherige Kursvariante konnte nicht ersetzt werden. Bitte versuche es noch einmal.');
        }
        if (!existing) {
          // Recheck after network delay, especially across the registration boundary.
          if (!campaignState(Date.now(), config).canBuy) throw new Error('Die Anmeldung ist inzwischen geschlossen.');
          const addUrl = new URL(form.getAttribute('action'), scope.location.href);
          addUrl.pathname = addUrl.pathname.replace(/\.js$/, '') + '.js';
          const item = {id: Number(id), quantity: 1};
          if (webinarBonusProperties) item.properties = webinarBonusProperties;
          const response = await fetch(addUrl.toString(), {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, credentials: 'same-origin', body: JSON.stringify({items: [item]})});
          const result = await response.json();
          if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'Der Kurs konnte nicht hinzugefügt werden. Bitte prüfe die Verfügbarkeit.');
        } else if (webinarBonusProperties && !existing.properties?.['_FMS Webinar-Boni']) {
          const changeResponse = await fetch(root.dataset.cartUrl + '/change.js', {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, credentials: 'same-origin', body: JSON.stringify({id: existing.key, quantity: existing.quantity, properties: webinarBonusProperties})});
          if (!changeResponse.ok) throw new Error('Die Webinar-Boni konnten nicht vorgemerkt werden. Bitte versuche es noch einmal.');
        }
        // A pre-existing cart or a slow add request can also span the closing time.
        if (!campaignState(Date.now(), config).canBuy) throw new Error('Die Anmeldung ist inzwischen geschlossen.');
        scope.location.assign(root.dataset.checkoutUrl);
      } catch (error) {
        status.textContent = error.message || 'Das hat leider nicht geklappt. Bitte versuche es noch einmal.';
        delete root.dataset.cartBusy;
        delete button.dataset.busy;
        render();
      }
    }));
  }
  const start = () => document.querySelectorAll('[data-fms-course-root]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true}); else start();
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-fms-course-root]').forEach(init));
})(typeof window !== 'undefined' ? window : globalThis);
